import React from 'react';
import LanguageSelector from './LanguageSelector';

interface LanguageFlagPickerProps {
    compact?: boolean;
}

const LanguageFlagPicker: React.FC<LanguageFlagPickerProps> = ({ compact = false }) => {
    return <LanguageSelector variant={compact ? 'minimal' : 'compact'} />;
};

export default LanguageFlagPicker;
